import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { company, navigation } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white/80 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#home" className="flex items-center gap-2 group">
            <div className="w-10 h-10 rounded-lg bg-yellow-400 flex items-center justify-center shadow-sm group-hover:rotate-3 transition-transform">
              <span className="font-black text-slate-900 text-lg">DK</span>
            </div>
            <div className="leading-tight">
              <div className="font-bold text-slate-900">{company.name}</div>
              <div className="text-xs text-slate-500 -mt-0.5">{company.experience}</div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {navigation.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:h-0.5 after:w-0 after:bg-yellow-400 hover:after:w-full after:transition-all"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${company.phoneRaw}`}
              className="flex items-center gap-2 text-sm font-semibold text-slate-900 hover:text-yellow-600 transition-colors"
            >
              <Phone className="w-4 h-4" />
              {company.phone}
            </a>
            <Button
              asChild
              className="bg-yellow-400 hover:bg-yellow-500 text-slate-900 font-semibold"
            >
              <a href="#contact">Offerte aanvragen</a>
            </Button>
          </div>

          <button
            className="lg:hidden p-2 text-slate-900"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-4 space-y-1">
            {navigation.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="block px-3 py-2 rounded-lg text-slate-700 hover:bg-slate-50 hover:text-slate-900 font-medium"
              >
                {item.label}
              </a>
            ))}
            <div className="pt-2 flex flex-col gap-2">
              <a
                href={`tel:${company.phoneRaw}`}
                className="flex items-center gap-2 px-3 py-2 text-sm font-semibold text-slate-900"
              >
                <Phone className="w-4 h-4" />
                {company.phone}
              </a>
              <Button asChild className="bg-yellow-400 hover:bg-yellow-500 text-slate-900 font-semibold w-full">
                <a href="#contact" onClick={() => setOpen(false)}>Offerte aanvragen</a>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
